import React from 'react';
import { Education } from '../../../../../types/resume';
import EducationItem from './EducationItem';

interface Props {
  education: Education[];
  onUpdate: (education: Education[]) => void;
}

export default function EducationList({ education, onUpdate }: Props) {
  const updateEducation = (id: string, updates: Partial<Education>) => {
    const updated = education.map(edu => 
      edu.id === id ? { ...edu, ...updates } : edu
    );
    onUpdate(updated);
  };

  const removeEducation = (id: string) => {
    onUpdate(education.filter(edu => edu.id !== id));
  };

  return (
    <div className="space-y-6">
      {education.map((edu, index) => (
        <EducationItem
          key={edu.id}
          education={edu}
          index={index}
          onUpdate={updateEducation}
          onRemove={removeEducation}
        />
      ))}
    </div>
  );
}